<template>
  <v-card @keyup.enter="blurAndConfirmNewCashEntry">
    <v-card-title class="headline">
      {{ $t('common.newCashEntry') }} - {{ cityName }}
    </v-card-title>
    <v-card-text v-if="infoFieldValue !== undefined">{{ infoFieldValue }}</v-card-text>
    <v-form ref="form">
      <v-flex xs12 style="margin: 0 16px;">
        <v-text-field
          ref="amount"
          v-model="newCashEntry.amount"
          :label="$t('common.amount')"
          :rules="[rules.required,
                   rules.notEqualToZero,
                   rules.paymentDecimal,
                   rules.isNumber,
                   rules.numberLessThan(1000000),
                   rules.numberMoreThan(-1000000)]"
          :name="$t('common.amount')"
          required
        />
        <v-text-field
          ref="comment"
          v-model="newCashEntry.comment"
          :label="$t('common.comment')"
          :rules="[rules.lengthNotGreaterThan]"
          :name="$t('common.comment')"
        />
      </v-flex>
    </v-form>
    <v-card-actions>
      <v-spacer />
      <v-btn flat="flat" @click="cancel()">
        {{ $t('common.cancel') }}
      </v-btn>
      <v-btn
        color="primary"
        :disabled="newCashEntry.loading"
        :loading="newCashEntry.loading"
        @click="confirmNewCashEntry()"
      >
        {{ $t('common.confirm') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ValidationService from '@/services/ValidationService';
import NotificationService from '@/services/NotificationService';
import { mapGetters } from 'vuex';

export default {
  name: 'NewCashEntryModal',
  props: {
    infoFieldValue: {
      type: String,
      default: undefined,
    },
  },
  data: () => ({
    newCashEntry: {
      amount: '',
      comment: '',
      loading: false,
    },
    rules: {
      required: ValidationService.rules.required(),
      notEqualToZero: ValidationService.rules.notEqualToZero(),
      paymentDecimal: ValidationService.rules.paymentDecimal(),
      isNumber: ValidationService.rules.isNumber(),
      lengthNotGreaterThan: ValidationService.rules.lengthNotGreaterThan('Value must not exceed 500 characters.', 500),
      numberLessThan: ValidationService.rules.numberLessThan(),
      numberMoreThan: ValidationService.rules.numberMoreThan(),
    },
  }),
  computed: {
    ...mapGetters('userInfoStore', ['userData', 'cities']),
    cityName() {
      return this.userData.cityId ? `${this.cities.find(x => x.id === this.userData.cityId).name}` : '';
    },
  },
  methods: {
    blurAndConfirmNewCashEntry() {
      document.activeElement.blur();
      this.confirmNewCashEntry();
    },
    confirmNewCashEntry() {
      const newCashEntryValid = ValidationService.validate(
        Object.keys(this.$refs)
          .filter(k => k !== 'form')
          .map(k => this.$refs[k]),
      );
      if (newCashEntryValid) {
        this.$emit('new-cash-entry-confirmed', this.newCashEntry);
      } else {
        setTimeout(() => {
          const invalidFieldNames = [...new Set(ValidationService.getInvalidFieldNames())];
          NotificationService.showAlert({
            message: this.$t('common.invalidFields', { fields: invalidFieldNames.join(', ') }),
            level: 'error',
          });
        });
      }
    },
    cancel() {
      this.$emit('close-dialog');
    },
    formInputReset() {
      this.$refs.form.reset();
      this.newCashEntry.amount = '';
      this.newCashEntry.comment = '';
      this.newCashEntry.loading = false;
    },
  },
};
</script>
